import { tv } from '@/utils/libs/tailwind-variants';
/**
 * HotlineClientScheduleConfirmModal のスタイル
 */
export const hotlineClientScheduleConfirmModalStyle = tv({
    slots: {
        base: ['!max-w-[min(416px,100%)]'],
        button: ['sm:max-[200px]'],
        buttonWrap: [
            'flex flex-col sm:flex-row-reverse justify-center gap-16',
            'mt-24',
        ],
        content: ['flex flex-col gap-16'],
    },
});
